<template>
  <div
    :class="
      twMerge(
        'p-2 bg-primary rounded-lg w-full',
        props.variant === 'yellow' && 'bg-primary-yellow',
        props.variant === 'red' && 'bg-secondary',
        props.variant === 'black' && 'bg-natural-black'
      )
    "
    :data-testid="props.dataTestid"
  >
    <div
      :class="
        twMerge(
          'border border-[#4792D8] rounded-lg p-2 mb-4 max-w-max flex items-center',
          props.variant === 'yellow' && 'border-[#D2BE22]',
          props.variant === 'red' && 'border-[#C31F24]',
          props.variant === 'black' && 'border-[#767B80]'
        )
      "
    >
      <TsCheckbox
        :input-class="
          twMerge(
            'bg-primary border border-white mr-1.5 text-primary focus:border-white checked:text-primary checked:border-white size-[14px]',
            props.variant === 'yellow' &&
              'bg-primary-yellow border-natural-black text-natural-black focus:border-natural-black checked:text-primary-yellow checked:border-natural-black',
            props.variant === 'red' && 'bg-[#C82328] checked:text-[#C82328]',
            props.variant === 'black' && 'bg-natural-black checked:text-natural-black'
          )
        "
      />
      <TsTypography
        :append-class="
          twMerge('text-idle-white mb-0', props.variant === 'yellow' && 'text-natural-black')
        "
        size="sm"
      >
        Coupon: <strong>{{ props.couponCode }}</strong>
      </TsTypography>
    </div>

    <TsImage
      v-if="props.image"
      class="mx-auto mb-4"
      :src="props.image"
      width="146"
      height="203"
      loading="lazy"
    />

    <div class="p-2">
      <TsTypography
        :append-class="
          twMerge('text-idle-white mb-0', props.variant === 'yellow' && 'text-natural-black')
        "
        size="sm"
      >
        {{ props.promoText }}
      </TsTypography>
      <TsTypography
        variant="h2"
        weight="bold"
        :append-class="
          twMerge('text-idle-white mb-2', props.variant === 'yellow' && 'text-natural-black')
        "
      >
        {{ props.title }}
      </TsTypography>
      <TsTypography
        :append-class="
          twMerge('text-idle-white mb-0', props.variant === 'yellow' && 'text-natural-black')
        "
        size="sm"
      >
        {{ props.configuration }}
      </TsTypography>
    </div>
  </div>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

type ColorVariants = 'blue' | 'yellow' | 'red' | 'black';

type Props = {
  couponCode?: string;
  image?: string;
  promoText?: string;
  title?: string;
  configuration?: string;
  variant?: ColorVariants;
  dataTestid?: string;
};

const TsCheckbox = defineAsyncComponent(() => import('~/components/atoms/TsCheckbox.vue'));

const props = withDefaults(defineProps<Props>(), {
  couponCode: 'FLATDEAL',
  image: '/images/deals-and-offers-1.png',
  promoText: 'Tool Up for Savings',
  title: 'Grab Your Gear Now!',
  configuration: 'Triton JOF001 router 1,010W 6-12mm',
  variant: 'blue',
  dataTestid: 'molecule-deals-and-offers',
});
</script>
